export const layoutUtils = {
  sideBarButtons: {
    admin: [
      { path: "/admin", key: "dashboard", icon: "tachometer-alt" },

      {
        path: "/admin/factures",  // or "/admin/invoices" depending on your routing
        key: "invoices",
        icon: "invoice" // FontAwesome icon for invoices
      },

      {
        path: "/admin/gifts",
        key: "gifts",
        icon: "gift" // FontAwesome icon for gifts
      },
      {
        path: "/admin/gift-requests",
        key: "giftRequests",
        icon: "gift-request" // You can use "gift" or "gift-bag" from FontAwesome
      },
      {
        path: "/admin/sanctions",
        key: "sanctions",
        icon: "exclamation-triangle",
      },
      {
        path: "/admin/ReclamationsDesClients",
        key: "clientComplaints",
        icon: "clipboard-list",
      },
      {
        path: "/admin/ApprobationDesContenus",
        key: "contentApproval",
        icon: "check-circle",
      },
      {
        path: "/admin/GestionDesRolesEtPermissions",
        key: "rolesPermissions",
        icon: "lock",
      },
      {
        path: "/admin/AnalyseEtReporting",
        key: "analytics",
        icon: "chart-line",
      },
      {
        path: "/admin/CentreDeSupport",
        key: "supportCenter",
        icon: "life-ring",
      },
      {
        path: "/admin/credentials",
        key: "companyInfo",
        icon: "building",
      },
      {
        path: "/admin/facturation/configuration",
        key: "billingConfig",
        icon: "pricing",
      },
      {
        path: "/admin/ai",
        key: "aiConfig",
        icon: "cogs",
      },
      {
        path: "/admin/oauth",
        key: "oauthConfig",
        icon: "oauth",
      },
      {
        path: "/admin/company",
        key: "companyManagement",
        icon: "company",
      },
      {
        path: "/admin/manage-access",
        key: "companyAccess",
        icon: "access",
      },
      {
        path: "/admin/quick-surveys",
        key: "quickSurvey",
        icon: "quick-survey",
      },
    ],
  },
};
